
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-72 -28 144 96"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#cd2a3e","d":"M-72-28H72v96H-72z"}}),_c('path',{attrs:{"fill":"#006233","d":"M-72-13.6H72v67.2H-72z"}}),_c('path',{staticClass:"st1",attrs:{"d":"M30 2.92c-.08 16.496-13.488 29.84-30 29.84S-29.92 19.416-30 2.92a30.973 30.973 0 00-1.008 7.84c0 17.12 13.872 31.008 31.008 31.008S31.008 27.896 31.008 10.76A30.88 30.88 0 0030 2.92z","fill":"#ffc400"}}),_c('path',{attrs:{"d":"M0-9.24L-2.694-.949h-8.719l7.053 5.126-2.693 8.291L0 7.344l7.053 5.124L4.36 4.177l7.053-5.125H2.694z","fill":"#ffc400"}})])
          )
        }
      }
    